import { ReactElement } from 'react';
import classNames from 'classnames';

interface Column {
  key: string;
  label: string;
}

interface TableProps {
  columns: Column[];
  data: { [key: string]: string | number }[];
  intercalatedColors?: boolean;
  centered?: boolean;
  scrollable?: boolean;
  className?: string;
}

const Table = ({
  columns,
  data,
  intercalatedColors = false,
  centered = false,
  scrollable = false,
  className,
}: TableProps): ReactElement => {
  return (
    <div className={classNames({ 'overflow-x-auto': scrollable }, className)}>
      <table
        className={classNames('table-auto w-full', {
          'text-center': centered,
        })}
      >
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index} className="border-b border-neutral-50 px-4 py-2 bg-blue-100">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={classNames({ 'bg-blue-100': intercalatedColors && rowIndex % 2 === 1 })}
            >
              {columns.map((column, colIndex) => (
                <td key={colIndex} className="border-b border-neutral-50 px-4 py-2">
                  {row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
